import React, { useState, useEffect } from 'react';
import notices from '../data/notices.json';

const READ_KEY = 'ondoku_read_notices';

function getReadIds() {
  try {
    return JSON.parse(localStorage.getItem(READ_KEY) || '[]');
  } catch {
    return [];
  }
}

function markAllRead(ids) {
  try {
    const existing = getReadIds();
    const merged = Array.from(new Set([...existing, ...ids]));
    localStorage.setItem(READ_KEY, JSON.stringify(merged));
  } catch {}
}

/** 未読のお知らせ一覧を返す */
export function getUnreadNotices() {
  const readIds = getReadIds();
  return notices.filter((n) => !readIds.includes(n.id));
}

/** important=true の未読があるか */
export function hasImportantUnread() {
  return getUnreadNotices().some((n) => n.important);
}

const typeIcon = {
  update: '✨',
  maintenance: '🔧',
  info: '📝',
};

const POPUP_MAX = 3; // ポップアップ時の最大表示件数

export default function NoticeBoard({ onClose, showAll = false, onShowAll }) {
  const [openId, setOpenId] = useState(null);
  const unread = getUnreadNotices();

  // showAll=true（設定画面から手動で開く）: 全件・新しい順
  // showAll=false（自動ポップアップ）: 未読の新しい順で最大3件
  const allUnread = unread.length > 0 ? [...unread].reverse() : [...notices].slice(-POPUP_MAX).reverse();
  const [items] = useState(() => {
    if (showAll) return [...notices].reverse();
    return allUnread.slice(0, POPUP_MAX);
  });
  const hasMore = !showAll && allUnread.length > POPUP_MAX;

  useEffect(() => {
    // マウント時にスクロール禁止
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  }, []);

  const handleClose = () => {
    markAllRead(items.map((n) => n.id));
    onClose();
  };

  const toggle = (id) => setOpenId((prev) => (prev === id ? null : id));

  return (
    <div className="noticeboard-overlay" onClick={handleClose}>
      <div
        className="noticeboard-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="noticeboard-header">
          <span className="noticeboard-title">📢 お知らせ</span>
          <span className="noticeboard-count">
            {showAll ? `全${items.length}件` : unread.length > 1 ? `${items.length}件` : null}
          </span>
        </div>

        <div className="noticeboard-list">
          {items.map((notice) => {
            const isRead = showAll && !unread.some((u) => u.id === notice.id);
            return (
            <div key={notice.id} className={`noticeboard-item${isRead ? ' noticeboard-item--read' : ''}`}>
              <button
                className="noticeboard-item-header"
                onClick={() => toggle(notice.id)}
              >
                <span className="noticeboard-item-icon">
                  {typeIcon[notice.type] ?? '📝'}
                </span>
                <span className="noticeboard-item-date">{notice.date}</span>
                <span className="noticeboard-item-title">{notice.title}</span>
                {notice.body && (
                  <span className="noticeboard-item-arrow">
                    {openId === notice.id ? '▼' : '▶'}
                  </span>
                )}
              </button>
              {notice.body && openId === notice.id && (
                <div className="noticeboard-item-body">{notice.body}</div>
              )}
            </div>
            );
          })}
        </div>

        {hasMore && onShowAll && (
          <button
            className="noticeboard-btn-more"
            onClick={() => { markAllRead(items.map((n) => n.id)); onShowAll(); }}
          >
            もっとみる（あと{allUnread.length - POPUP_MAX}件）
          </button>
        )}
        <button className="noticeboard-btn-ok" onClick={handleClose}>
          OK
        </button>
      </div>
    </div>
  );
}
